export function handleTerrainDoubleClick(
  event, 
  camera, 
  controls, 
  raycaster, 
  mouse, 
  collidableMeshes, 
  surfaceGroup, 
  surfaceY, 
  cameraPositions, 
  REGISTRO_PUTNOS, 
  RUTA_GLOBAL, 
  profundidadDisplay
) {
  // 1. Guardar la posición de la cámara y su target
  const position = camera.position.clone();
  const target = controls ? controls.target.clone() : new THREE.Vector3(0, 0, 0);

  const cameraData = {
    position: { x: position.x, y: position.y, z: position.z },
    target: { x: target.x, y: target.y, z: target.z }
  };

  cameraPositions.push(cameraData);
  console.log("Cámara capturada:", cameraData);

  // 2. Validaciones de interfaz y entorno
  if (document.getElementById('nueva_rutaMenu')?.classList.contains('open')) return false;
  
  

  // 3. Configurar Raycaster con el clic del mouse
  mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
  mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
  raycaster.setFromCamera(mouse, camera);
  
  const intersects = raycaster.intersectObjects(collidableMeshes, true);

  if (intersects.length > 0) {
    const hitPoint = intersects[0].point;
    console.log('Intersección detectada:', { object: intersects[0].object.name || 'Sin nombre', point: hitPoint });
    
    // Calcular profundidad relativa
    const profundidadRelativaMetros = (surfaceY - hitPoint.y) * 800;

    if (profundidadRelativaMetros > 40) {
      profundidadDisplay.innerHTML = `📍Non-recreational depth`;
      alertas('Exceeds recreational depths. Has not been successfully added.');
    } else {
      profundidadDisplay.innerHTML = `<a onclick=info_arrecife()>Cozumel Map 🔍<br>📍</a>`;

      const nuevoPunto = {
        X: hitPoint.x.toFixed(2),
        Y: hitPoint.y.toFixed(2),
        Z: hitPoint.z.toFixed(2),
        depth: profundidadRelativaMetros.toFixed(2),
        time: 10
      };

      // Registrar punto (para log interno)
      REGISTRO_PUTNOS.data.push(nuevoPunto);
      console.log('REGISTRO_PUTNOS:', JSON.stringify(REGISTRO_PUTNOS));

      // Puntos para planeación de buceo (Máximo 7 puntos: index 0 al 6)
      if (RUTA_GLOBAL.data.length > 6) {
        alertas('Maximum allowed.');
      } else {
        RUTA_GLOBAL.data.push(nuevoPunto);
        // Si tienes la función "actualizar_num_rutas();" descoméntala aquí:
        // actualizar_num_rutas();
      }
    }
  } 

  // Retornamos true para indicarle al script que necesita renderizar el cambio
  return true;
}